import { initLocalization, useTranslation } from "@stenpro/localization";

import sv from "../../i18n/sv-SE.json";
import en from "../../i18n/en-US.json";

const defaultLanguage = "sv-SE";
const supportedLanguages = [defaultLanguage, "en-US"] as const;
const languageAliases = { sv: defaultLanguage, en: "en-US" };

initLocalization({
  resources: {
    [defaultLanguage]: { translation: sv },
    "en-US": { translation: en },
  },
  defaultLanguage,
  fallbackLanguage: defaultLanguage,
  language: defaultLanguage,
  supportedLanguages,
  aliases: languageAliases,
});

export { useTranslation };
